import { BookOpen, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

import { getCategoriesForRole, roleLabels, type Role } from '../../content/registry';

import { CategorySection } from './CategorySection';

interface RoleTopPageProps {
  role: Role;
}

export function RoleTopPage({ role }: RoleTopPageProps) {
  const filteredCategories = getCategoriesForRole(role);
  const label = roleLabels[role];

  return (
    <div>
      {/* Page title */}
      <div className='mb-10'>
        <div className='mb-2 flex items-center gap-3'>
          <div className='flex h-10 w-10 items-center justify-center rounded-lg bg-accent'>
            <BookOpen size={22} className='text-primary' />
          </div>
          <h1 className='text-2xl font-bold text-text'>{label}向けガイド</h1>
        </div>
        <p className='ml-[52px] text-sm text-text-secondary'>{label}に関連する操作方法・設定</p>
        <Link to='/' className='ml-[52px] mt-2 inline-block text-sm text-primary hover:underline'>
          すべてのガイドを見る
        </Link>
      </div>

      {/* Filtered category sections */}
      {filteredCategories.map((category) => (
        <CategorySection key={category.id} category={category} fromRole={role} />
      ))}

      {/* Release notes link */}
      <div className='mt-10 border-t border-border pt-8'>
        <Link
          to='/release-notes'
          className='inline-flex items-center gap-2 text-sm text-text-secondary transition-colors hover:text-primary'
        >
          <FileText size={16} />
          リリースノート
        </Link>
      </div>
    </div>
  );
}
